import i18n from '../../language/index'
import {create_title} from '@/base/titleData';
import pageData from './../../base/pageData'
import {box_shadow_style_add, getBackgroundData, getCommonStyle} from "@/base/widgets_data_compatible";

export default {
  img_effects: {
    id: 1,
    formData: {
      effect: 0,//当前选中的特效
      border: {
        radio_val: 'default',
        default: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        },
        custom: {
          borderWidth: 2,
          borderColor: "rgba(0, 0, 0, 1)",
        }
      },
      background: {
        radio_val: 'default',
        default: {
          color: "rgba(255, 255, 255, 0)",
        },
        custom: {
          color: "rgba(255, 255, 255, 1)",
        }
      },
      direction: 'left'
    }
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor:{
    marginTop:'0%',
    marginLeft:'0%',
    marginRight:'0%',
    marginBottom:'0%',
  },
  pc_widgets_infor:{
    backgroundType:{
      radio_val: 'default',
      default: {
          backgroundSize: 'cover'
      },
      custom: {
          backgroundSize: 'auto'
      }
    },
    page: pageData,
    title:create_title(i18n.t('widgets_basic_searchs_results_edit_2861')),
    height:{
      radio_val: 'default',
      default: {
        height: '100%',
      },
      custom: {
        height: '100%',
      }
    },
    lineNumber:{
      radio_val: 'default',
      default: {
        value: 4,
      },
      custom: {
        value: 4,
      }
    },
    margin:{
      radio_val: 'default',
      default: {
        marginLeft: 20,
        marginTop:20
      },
      custom: {
        marginLeft: 20,
        marginTop:20
      }
    },
    borderRadius: {
      ...getCommonStyle().borderRadius
    },
    ...box_shadow_style_add(),
    ...getBackgroundData(),
  },
  mb_widgets_infor: {
    title:create_title(i18n.t('widgets_basic_searchs_results_edit_2861')),
    page: pageData,
    backgroundType:{
      radio_val: 'default',
      default: {
          backgroundSize: 'cover'
      },
      custom: {
          backgroundSize: 'auto'
      }
    },
    height:{
      radio_val: 'default',
      default: {
        height: '100%',
      },
      custom: {
        height: '100%',
      }
    },
    lineNumber:{
      radio_val: 'default',
      default: {
        value: 2,
      },
      custom: {
        value: 2,
      }
    },
    margin:{
      radio_val: 'default',
      default: {
        marginLeft: 20,
        marginTop:20
      },
      custom: {
        marginLeft: 20,
        marginTop:20
      }
    }
  },
  listArr:{
    styleType:'type1'
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_searchs_results/style.js